import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { GeolocationComponent } from './geolocation.component';
import { CitiesModule } from '@app/modules/cities-module/cities.module';

/**
 * Vendors
 */
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';

@NgModule({
  declarations: [
    GeolocationComponent
  ],
  exports: [
    GeolocationComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    CitiesModule
  ],
  providers: [
    DialogService,
    DynamicDialogRef,
    DynamicDialogConfig
  ]
})

export class GeolocationModule {
  constructor() {}
}
